import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../utils/formatCurrency';
import './WaiterSummaryBar.css';

function WaiterSummaryBar({ tables, orders }) {
  const { t } = useTranslation();

  const totalTables = tables.length;
  const tablesWithUnpaidOrders = new Set();
  orders.forEach((order) => {
    if (order.status !== 'cancelled' && order.paymentStatus !== 'paid' && order.tableNumber) {
      tablesWithUnpaidOrders.add(String(order.tableNumber));
    }
  });
  const occupiedTables = tables.filter(
    (table) => table.status === 'occupied' || table.currentSessionId || table.sessionId || tablesWithUnpaidOrders.has(String(table.tableNumber))
  ).length;

  // Count tables with ready items
  const tablesWithReadyItems = new Set();
  orders.forEach((order) => {
    if (order.status === 'ready' && order.tableNumber) {
      tablesWithReadyItems.add(String(order.tableNumber));
    }
  });

  // Calculate total billing
  const totalBilling = orders
    .filter((o) => o.status !== 'cancelled')
    .reduce((sum, o) => sum + (o.total || 0), 0);

  return (
    <div className="waiter-summary-bar">
      <div className="summary-stat">
        <span className="summary-value">{totalTables}</span>
        <span className="summary-label">{t('waiter.totalTables')}</span>
      </div>
      <div className="summary-divider" />
      <div className="summary-stat">
        <span className="summary-value summary-occupied">{occupiedTables}</span>
        <span className="summary-label">{t('waiter.occupied')}</span>
      </div>
      <div className="summary-divider" />
      <div className="summary-stat">
        <span className="summary-value summary-ready">{tablesWithReadyItems.size}</span>
        <span className="summary-label">{t('waiter.readyToServe')}</span>
      </div>
      <div className="summary-divider" />
      <div className="summary-stat">
        <span className="summary-value summary-billing">
          {formatCurrency(totalBilling)}
        </span>
        <span className="summary-label">{t('waiter.billing')}</span>
      </div>
    </div>
  );
}

export default WaiterSummaryBar;
